<template>
 <div class="card" id="contactouders">
    <header class="card-header">
      <p class="card-header-title">
        Contact ouders met school
      </p>
    </header>
    <div class="card-content">
      <section>
        <template v-for="item in items">
          <b-field :label="item.name" :key="item.id" v-if="item.marktype === 'text'">
            <b-input v-model="selected[item.usersequence-1]" @blur="update_verzuim({id:item.id,mark:selected[item.usersequence-1] })"></b-input>
          </b-field>
          <b-field :key="item.id" v-if="item.marktype === 'check'">
            <b-checkbox v-model="selected[item.usersequence-1]" @input="update_verzuim({id:item.id,mark:selected[item.usersequence-1] })">{{item.name}}</b-checkbox>
          </b-field>
          <b-field :label="item.name" :key="item.id" v-if="item.marktype === 'select'">
            <b-select v-model="selected[item.usersequence-1]" placeholder="Select" @input="update_verzuim({id:item.id,mark:selected[item.usersequence-1] })">
              <option v-for="item in JSON.parse(item.mark)" :label="item" :value="item" :key="item">
              </option>
            </b-select>
          </b-field>
        </template>
      </section>
    </div>
  </div>
<!-- <div v-loading.body="loading" element-loading-text="Laden...">
  <el-card class="box-card" id="contactouders" style="height:595px;">
    <div slot="header">
      <span class="okrhead">Contact ouders met school</span>
    </div>

    <template v-for="item in items">
        <el-form-item class="okritem" :label="item.name" :key="item.id" label-width="350px">
          <el-input v-if="item.marktype === 'text'" size="small" style="width:175px;" v-model="selected[item.usersequence-1]" @blur="update_verzuim({id:item.id,mark:selected[item.usersequence-1] })"></el-input>
          <el-checkbox v-if="item.marktype === 'check'" v-model="selected[item.usersequence-1]" @change="update_verzuim({id:item.id,mark:selected[item.usersequence-1] })"> </el-checkbox>
          <el-select v-if="item.marktype === 'select'" v-model="selected[item.usersequence-1]" filterable placeholder="Select" @change="update_verzuim({id:item.id,mark:selected[item.usersequence-1] })">
            <el-option
              v-for="item in JSON.parse(item.mark)"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
</template>
  </el-card>
</div> -->
</template>

<script>
import Axios from 'axios'
import moment from 'moment'
import {
  API_ROOT
} from '../../config'

var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 600000

});

console.log(API_ROOT);
export default {
  name: 'contactouders',
  props: ['studentid'],
  data: function() {
    return {
      items: [{
        id: '',
        name: '',
        marktype: '',
        usersequence: '',
        mark: ''
      }, {
        id: '',
        name: '',
        marktype: '',
        usersequence: '',
        mark: ''
      }, {
        id: '',
        name: '',
        marktype: '',
        usersequence: '',
        mark: ''
      }, {
        id: '',
        name: '',
        marktype: '',
        usersequence: '',
        mark: ''
      }, {
        id: '',
        name: '',
        marktype: '',
        usersequence: '',
        mark: ''
      }, {
        id: '',
        name: '',
        marktype: '',
        usersequence: '',
        mark: ''
      }, {
        id: '',
        name: '',
        marktype: '',
        usersequence: '',
        mark: ''
      }, {
        id: '',
        name: '',
        marktype: '',
        usersequence: '',
        mark: ''
      }],
      selected: ['', '', '', '', '', '', '', ''],
      loading:false
    }
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetch_data()
  },
  methods: {
    fetch_data() {
      console.log('Loading contact_ouders component...');
      var self = this;

      instance.get('/miscellaneous/type/8').then(function(response) {

        var arr_obj = [];
        for (var i = 0; i < response.data.data.length; i++) {
          arr_obj.push({
            id: response.data.data[i].id,
            name: response.data.data[i].name,
            usersequence: response.data.data[i].usersequence,
            mark: response.data.data[i].tbl_sys_miscellaneous_mark_types[0].tbl_conf_mark.mark,
            marktype: response.data.data[i].tbl_sys_miscellaneous_mark_types[0].tbl_conf_mark.type
          });
        }
        _.merge(self.items, arr_obj)

        console.log(arr_obj);
        console.log('Populate mark');
        console.log(self.$route.params.id);
        self.loading = true;
        instance.get('/student-misc-mark-student', {
          params: {
            student_id: self.$route.params.id,
            sys_miscellaneous_id: 8
          }
        }).then(function(response) {
          console.log('Populating');
          console.log(response.data.data);
          if (response.data.data.length > 0) {
            var obj_mark = response.data.data
            var sel = []

            for (var i = 0; i < obj_mark.length; i++) {
              var sequence = obj_mark[i].tbl_sys_miscellaneou.usersequence - 1;
              //sel.push(obj_mark[i].mark);
              //self.selected.push(obj_mark[i].mark);
              console.log(self.items[sequence].marktype);
              console.log(obj_mark[i].mark);


              if (self.items[sequence].marktype == 'check') {
                if (obj_mark[i].mark == '1') {
                  self.$set(self.selected, sequence, true);
                } else {
                  self.$set(self.selected, sequence, false);
                }

              } else {
                self.$set(self.selected, sequence, obj_mark[i].mark);
              }

            }
            console.log(sel);
            //  _.merge(self.selected,sel);
          }

          self.loading=false;
          self.$store.dispatch('load', {
            name: 'contactouders',
            value: false
          });
        });

        console.log(self.items);
        console.log(self.selected);

      });
    },

    update_verzuim(obj) {
      //first delete all disabilities the nsave new list
      console.log('Update mark');
      console.log(obj);

      instance.post('/student-misc-mark/update', {
        student_id: this.studentid,
        sys_miscellaneous_id: obj.id,
        mark: obj.mark
      }).then(function(response) {
        //console.log(response.data.data);
      });


    }
  }
}
</script>
<style scoped>
.okrhead {
  font-size: 20px;
  font-weight: bold;
}

.okritem {
  margin-bottom: 5px;
}
</style>
